<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="getData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.nickname" placeholder="请输入用户昵称" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="bizKey" label="通知类型" width="120"></el-table-column>
            <el-table-column prop="title" label="标题" width="160"></el-table-column>
            <el-table-column prop="summary" label="概要" width="200"></el-table-column>
            <el-table-column prop="content" label="内容"></el-table-column>
            <el-table-column prop="createdAt" label="创建日期" width="160">
                <template slot-scope="scope">
                    {{ getFormatDate(scope.row.createdAt) }}
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            statusArray: [
                { value: 'active', label: '正常' },
                { value: 'banned', label: '已禁用' }
            ]
        }
    },
    methods: {
        getData: async function() {
            this.initialData();
        }
    },
    created: function () {
        this.tag = "USER_NOTIFICATIONS";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>